


import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
  useEffect(() => {
    // Simple fade-in animation for content
    const bannerContent = document.querySelector('.banner-content');
    if (bannerContent) {
      bannerContent.classList.add('opacity-0');
      setTimeout(() => {
        bannerContent.classList.remove('opacity-0');
        bannerContent.classList.add('opacity-100', 'transition-opacity', 'duration-1000');
      }, 100);
    }
  }, []);

  return (
    <div className="relative w-screen vw-full overflow-hidden bg-gradient-to-r from-orange-500 via-orange-400 to-yellow-300 h-96 sm:h-[400px] md:h-[500px]">
      {/* Background Overlay (Optional Image) */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80')] bg-cover bg-center opacity-20"></div>

      {/* Content */}
      <div className="relative z-10 banner-content flex flex-col items-center justify-center h-full text-center px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg">
          Find Your Dream Job Today
        </h1>
        <p className="text-white text-base sm:text-lg md:text-xl mb-6 max-w-md drop-shadow-md">
          Explore thousands of opportunities with top employers across Nigeria and beyond. Start your journey now!
        </p>
        <Link
          to="/jobs"
          className="bg-white text-orange-500 font-semibold py-3 px-6 rounded-full hover:bg-orange-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Explore Jobs Now
        </Link>
      </div>
    </div>
  );
};

export default Banner;